import { timeout } from '@ynap/promise-utils'
import { ResponseError } from '@ynap/api-utils'

export default function wrapFetchWithJSON(fetch, ms) {
    return (input, init) =>
        timeout(fetch(input, init), ms).then((response) => {
            if (!response.ok) {
                throw new ResponseError(response)
            }
            return response.json()
        })
}
